import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from 'util/locale';
import classNames from 'classnames';

import BaseTrigger from 'triggers/BaseTrigger';

const baseString = 'vra-add-seed-products-trigger';
const classString = classNames({
  [`${baseString}`]: true
});
const SearchSeedProductsTrigger = ({
  onClickSearchSeedProductsTrigger,
  isDisabled
}) => (
  <BaseTrigger
    className={classString}
    content={getMessage('button-text__search-seed-products')}
    dataTestId={baseString}
    disabled={isDisabled}
    handler={onClickSearchSeedProductsTrigger}
    mode='primary'
  />
);
SearchSeedProductsTrigger.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  onClickSearchSeedProductsTrigger: PropTypes.func.isRequired
};
export default SearchSeedProductsTrigger;
